import * as React from "react";

function SvgSuccessSmall(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} {...props}>
        <path
          d="M7.5 0a7.451 7.451 0 00-5.3 2.2A7.452 7.452 0 000 7.5a7.451 7.451 0 002.2 5.3A7.451 7.451 0 007.5 15a7.452 7.452 0 005.3-2.2A7.451 7.451 0 0015 7.5a7.451 7.451 0 00-2.2-5.3A7.451 7.451 0 007.5 0zm0 13.946a6.409 6.409 0 01-2.508-.505 6.459 6.459 0 01-2.049-1.382 6.416 6.416 0 01-1.382-2.049 6.4 6.4 0 01-.506-2.51 6.415 6.415 0 01.505-2.508 6.471 6.471 0 011.382-2.049 6.416 6.416 0 012.049-1.382A6.4 6.4 0 017.5 1.054a6.405 6.405 0 012.508.506 6.46 6.46 0 012.049 1.381 6.42 6.42 0 011.382 2.05 6.4 6.4 0 01.507 2.509 6.4 6.4 0 01-.506 2.508 6.41 6.41 0 01-1.383 2.049 6.416 6.416 0 01-2.049 1.382 6.387 6.387 0 01-2.508.506zm3.438-9.624a.522.522 0 00-.372.155l-4.8 4.812L4.517 7.1a.529.529 0 00-.458-.266.526.526 0 00-.261.07.524.524 0 00-.247.319.523.523 0 00.051.4L5.2 10.412a.529.529 0 00.458.267.517.517 0 00.261-.069.542.542 0 00.124-.1l.006-.006 5.266-5.282a.525.525 0 00.154-.373.523.523 0 00-.155-.373.519.519 0 00-.376-.154z"
          fill="#4caf50"
        />
      </svg>
    </span>
  );
}

export default SvgSuccessSmall;
